module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("selected")]), _vm._v(": " + _vm._s(_vm.selectedOptions))]), _vm._v(" "), _c('b-field', [_c('b-select', {
    attrs: {
      "multiple": "",
      "native-size": "8"
    },
    model: {
      value: (_vm.selectedOptions),
      callback: function($$v) {
        _vm.selectedOptions = $$v
      },
      expression: "selectedOptions"
    }
  }, [_c('option', {
    attrs: {
      "value": "flint"
    }
  }, [_vm._v("Flint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "silver"
    }
  }, [_vm._v("Silver")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vane"
    }
  }, [_vm._v("Vane")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "billy"
    }
  }, [_vm._v("Billy")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "jack"
    }
  }, [_vm._v("Jack")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "heisenberg"
    }
  }, [_vm._v("Heisenberg")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "jesse"
    }
  }, [_vm._v("Jesse")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "saul"
    }
  }, [_vm._v("Saul")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mike"
    }
  }, [_vm._v("Mike")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76dffec8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/select/examples/ExMultiple.vue
// module id = 1169
// module chunks = 29 102